import { jsx } from 'react/jsx-runtime';
import React, { useContext } from 'react';
import { getEnv } from '../env/environment.js';

const EnvironmentContext = React.createContext({});
const useEnv = () => {
    const env = useContext(EnvironmentContext);
    return env;
};
const EnvProvider = ({ stage, children }) => {
    const env = getEnv(stage);
    return (jsx(EnvironmentContext.Provider, { value: {
            ...env,
            isProduction: stage === 'prod',
        }, children: children }));
};

export { EnvProvider as default, useEnv };
//# sourceMappingURL=EnvProvider.js.map
